export function MediamarktPrivacyEN() {
  return (
    <article>
      <h1>Privacy Policy</h1>
      <time dateTime="2024-09-01">September 2024</time>

      <div>
        <p>
          This Privacy Policy applies to all of the products, services and
          websites offered by Jotta AS (Jottacloud). References to “we,” “our”
          and “us” refer to Jottacloud, while “you” and “your” refer to the
          Jottacloud customer or user.
        </p>
        <h3>The Information We Collect</h3>
        <p>
          When you visit Jottacloud’s services and websites you provide us with
          two types of information: Personal Data you knowingly choose to
          disclose that is collected by us, and Web Site use information
          collected by us as you interact with our services.
        </p>
        <h3>Information You Provide</h3>
        <p>
          When you register with Jottacloud, you provide us with your name, your
          email address and phone number hereinafter referred to as Personal
          Data.
        </p>
        <p>
          Passwords are encrypted in our databases. We cannot read your
          password. Jottacloud does not have access to your credit card
          information.&nbsp;
        </p>
        <p>
          If you are a registered user of Jottacloud, you acknowledge and agree
          that Jottacloud may occasionally send you important communications
          regarding your account or the Service via email or SMS.
        </p>
        <h3>Website Use Information</h3>
        <p>
          When you enter Jottacloud, we collect your browser type and IP
          address. This information is gathered for all Jottacloud visitors and
          users. In addition, we store certain information from your browser
          using “cookies.” A cookie is a piece of data stored on the user’s
          computer tied to information about the user. We use session ID cookies
          to confirm that registered users are logged in.&nbsp;
        </p>
        <p>
          We use persistent cookies to store website usage information.
          Persistent cookies are stored on your computer for a longer period of
          time. Such information is not personally identifiable.
        </p>
        <h3>Uploading Data</h3>
        <p>
          When you upload files to Jottacloud, you also send file system
          information, including names of files and directories. Files are
          encrypted with Secure Socket Layer (SSL) during transfer.
        </p>
        <h3>How we use the Information</h3>
        <ul>
          <li>
            We use the information we collect for purposes of providing the
            users high quality services, and to develop new products and
            services for our customers and prospective customers.
          </li>
          <li>
            We may view your file system metadata (filename, sizes etc. but not
            your file contents) to provide technical support.
          </li>
          <li>We will not sell or market your email address.</li>
          <li>We will not disclose your Personal Data to any third parties.</li>
          <li>
            We will not view the files that you upload to Jottacloud.&nbsp;
          </li>
        </ul>
        <h3>Children under Age 13</h3>
        <p>
          Children under 13 are not allowed to register with Jottacloud.
          Jottacloud does not knowingly collect or solicit Personal Data from
          anyone under the age of 13, or knowingly allow such persons to
          register.&nbsp;
        </p>
        <h3>Security</h3>
        <p>
          We use industry standard security measures to protect against the
          loss, misuse and alteration of the information under our control.
        </p>
        <p>
          Because email and instant messaging are not recognized as secure
          communications, we request that you not send sensitive Personal Data
          to us by email or instant messaging services.
        </p>
        <p>
          If you cancel your account, your data and other information may be
          retained in our archive or backup record until deleted after 90 days.
        </p>
        <h3>Links</h3>
        <p>
          Jottacloud may contain links to other websites. We are not responsible
          for the privacy practices of other web sites. This Privacy Policy
          applies solely to information collected by Jottacloud.
        </p>
        <h3>Access, Changes and Deletion of Personal Data&nbsp;</h3>
        <p>
          You have the right to require access, correction or deletion of
          Personal Data we are processing. You also have the right to demand
          limited treatment, objection to treatment and claim the right to data
          portability. You may withdraw your consent for processing Personal
          Data at any time.&nbsp;
        </p>
        <p>
          You can read more about the content of these rights on the Data
          Inspectorate's website:{' '}
          <a
            href="https://www.datatilsynet.no"
            rel="nofollow noopener noreferrer"
            target="_blank"
          >
            https://www.datatilsynet.no.
          </a>{' '}
          &nbsp;
        </p>
        <p>
          Your consent to store Personal Data is required to use our services.
          &nbsp;
        </p>
        <h3>Complaints</h3>
        <p>
          If you believe that our processing of Personal Data does not match
          what we have described here or we otherwise violate privacy laws, you
          may appeal to the Data Inspectorate. For information on how to contact
          the Data Inspectorate, visit the Data Inspectorate's website:{' '}
          <a
            href="https://www.datatilsynet.no"
            rel="nofollow noopener noreferrer"
            target="_blank"
          >
            https://www.datatilsynet.no
          </a>
          .
        </p>
        <h3>Changes to this Policy</h3>
        <p>
          Jottacloud reserves the right in our sole discretion to revise, amend,
          or modify this policy at any time. Notice of any revision, amendment,
          or modification of this policy will be posted on Jottacloud’s
          websites, and a User’s continued use of the Service will signify
          agreement to such changes. Notifications of the above-mentioned
          changes will be sent to the user via email.
        </p>
      </div>
    </article>
  )
}
